module.exports = __webpack_public_path__ + "img/bokispq.423502e9.png";